import { isValidEmailAddress, fadeOutNotifications } from '../functions';
import Swal from 'sweetalert2'

let isLoadingNewsletter = false;
$(document).on('click', '#send-newsletter-btn', function(e) {
	e.preventDefault();

	//$('#newsletter-token').removeClass('error');
	if (isLoadingNewsletter) {
		return false;
	}

	$('#newsletter_email').removeClass('is-invalid');
	$('#newsletter_terms_and_condition').removeClass('is-invalid');
	$('#newsletter_interested_in').removeClass('is-invalid');
	var errors = false;

	if ($('#newsletter_email').val() == '') {
		$('#newsletter_email').addClass('is-invalid');
		// $('#newsletter-response').html('<div class="alert alert-danger" role="alert">'+NEWSLETTER_EMAIL_REQUIRE+'</div>');
		errors = true;
		//return false;
	}

	if ($('#newsletter_interested_in option:selected').val() == '') {
		$('#newsletter_interested_in').addClass('is-invalid');
		// $('#newsletter-response').html('<div class="alert alert-danger" role="alert">'+NEWSLETTER_EMAIL_REQUIRE+'</div>');
		errors = true;
		//return false;
	}

	if (!$('#newsletter_terms_and_condition').is(":checked")) {
		$('#newsletter_terms_and_condition').addClass('is-invalid');
		//$('#newsletter-response').html('<div class="alert alert-danger" role="alert">'+NEWSLETTER_TERMS_AND_CONDITIONS+'</div>');
		errors = true;
		//return false;
	}

	if (errors) {
		return false;
	}

	//Loading...
	isLoadingNewsletter = true;
	let element = this;
	$(element).find('i').show();

	var values = '_token=' + encodeURIComponent($('meta[name="csrf-token"]').attr("content"));
	values += '&email=' + encodeURIComponent($('#newsletter_email').val());
	values += '&interested_in=' + encodeURIComponent($('#newsletter_interested_in option:selected').val());
	$.ajax({
		type: "POST",
		url: baseURL + "/newsletter/save",
		data: values,
		success: function(response) {
			isLoadingNewsletter = false;
			$(element).find('i').hide();

			$('#newsletter_email').val('');
			$('#newsletter_interested_in').val('');
			$('#newsletter_terms_and_condition').prop("checked", false);

			if (response.status == 0) {
				var errorHtml = '';
				for(var errorKey in response.errors) {
					if(!response.errors.hasOwnProperty(errorKey)) continue;
					for(var error in response.errors[errorKey]) {
						$("#"+errorKey).parent().addClass('has-error');
						errorHtml += response.errors[errorKey][error] + '<br>';
					}
				}

				Swal.fire({
					icon: 'error',
					title: POPUP_ERROR_TITLE,
					html: errorHtml
				});

				//$('#newsletter-response').html('<div class="alert alert-danger" role="alert">'+errorHtml+'</div>');
				return false;
			}

			if (response.status == 1) {

				//$('#newsletter-response').html('<div class="alert alert-success" role="alert">'+response.message+'</div>');

				if (cookies_advertisement == 1 || cookies_social == 1) {
					//fbq('track', 'Lead');
				}

				Swal.fire({
					icon: 'success',
					title: response.title,
					text: response.message
				});

				return;
			}

			Swal.fire({
				icon: 'error',
				title: POPUP_ERROR_TITLE,
				text: GENERAL_ERROR_MESSAGE
			});
		},
		error: function() {
			isLoadingNewsletter = false;
			$(element).find('i').hide();
		}
	});
});